import React, {Component} from 'react';
import Hammer from 'hammerjs';

import MapImageNormal from '../../assets/img/map.png';
import MapImageFallout from '../../assets/img/mapFallout.png';

import Cloud01 from '../../assets/img/mapCloud_1.png';
import Cloud02 from '../../assets/img/mapCloud_2.png';
import Plane from '../../assets/img/mapDecoration/Plane.png';


import Minus from '../../assets/img/icons/zoom_out.svg';
import Plus from '../../assets/img/icons/zoom_in.svg';
import BalloonEl from "./Balloon";
import Radiator from "./Radiation";
import Boom from "../../assets/audio/Bomb_3.mp3";

/**
 * Import assets
 */

let lastPosX ;
let lastPosY;
let lastPosZ;
let currentZ;
let minZoom;
let maxZoom;
let maxY;
let minY;
let zoomStep;
let desktop;
let MapImage;
let isDragging;
initDefaultVars();

function initDefaultVars() {
  lastPosX = 0;
  lastPosY = 0;
  lastPosZ = 1;
  currentZ = 1;
  minZoom = .5;
  maxZoom = 4;
  maxY = 50;
  minY = -50;
  zoomStep = undefined;
  desktop = false;
  MapImage = MapImageNormal;
  if (document.querySelector('#root').clientWidth >= 1240) {
    desktop = true;
    minZoom = .6;
    maxZoom = 1.4;
  }
  isDragging = false;
}

window.mapElementsAnimationTimePassed = 0;

export default class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapTop: 0,
      mapLeft: 0,
      currentZ: 1,
      maxZoom: maxZoom,
      minZoom: minZoom,
      zoomBarPercentage: 50,
      lowBudgetWarning: true,
      boom: false,
      nuuk: false,
      fallout: false,
    };
    this.draggable = React.createRef();
    this.mapElement = React.createRef();

    this.rafStarted = 0;
    this.raf = 0;
    this.animationTimePassedOnConstruct = window.mapElementsAnimationTimePassed;
    this.calculateZoomPercentage = this.calculateZoomPercentage.bind(this);
    if (!desktop) {
      initDefaultVars();
    }
  }

  toPercent(input, scale) {
    return (input / scale) * 100;
  }

  toPixel(input, scale) {
    if(input === 0){
      return 0;
    }
    return (input / 100) * scale;
  }

  panObject = (ev) => {
    let elem = document.querySelector('#draggable');
    const re = /(-{0,1}[0-9]+(\.[0-9]+)?%)/g;
    let transform = elem.style.transform;
    let translate3d = transform.match(re);

    if (!isDragging) {
      isDragging = true;
      if( translate3d !== null ){
        lastPosX = parseInt(translate3d[0], 10);
        lastPosY = parseInt(translate3d[1], 10);
      }
    }

    const map = document.querySelector('.map');
    let maxX = (((map.offsetWidth / elem.offsetWidth) - (1 / currentZ)) / 2) * 100;
    maxX = maxX + (((document.querySelector('body').offsetWidth - elem.offsetWidth) / 2) * ((1 / currentZ) / 2));

    if (desktop) {
      maxX = (maxX * .3);
    }

    let posX =
      (ev.deltaX === 0 ? lastPosX : this.toPercent((ev.deltaX / currentZ) + this.toPixel(lastPosX, elem.offsetWidth),
      elem.offsetWidth));
    let posY =
      (ev.deltaY === 0 ? lastPosY : this.toPercent((ev.deltaY / currentZ) + this.toPixel(lastPosY, elem.offsetHeight),
      elem.offsetHeight));

    if(posX > maxX) {
      posX = maxX + '%';
    } else if(posX < -maxX) {
      posX = -maxX + '%';
    }

    if(posY > maxY) {
      posY = maxY + '%';
    } else if(posY < minY) {
      posY = -maxY + '%';
    }

    const transformString =
      'translate3d('
      + parseFloat(posX).toFixed(2)
      + '%, '
      + parseFloat(posY).toFixed(2)
      + '%, 0)';

    if (ev.isFinal) {
      isDragging = false;
      if( translate3d !== null ){
        lastPosX = parseFloat(translate3d[0]).toFixed(2);
        lastPosY = parseFloat(translate3d[1]).toFixed(2);
      }
    }

    return transformString;
  };

  scaleObject = (ev) => {
    let output = 1;

    if(ev.type === 'wheel'){
      if(!ev.fake) {
        ev.preventDefault();
        zoomStep = .05;
      } else {
        zoomStep = .2;
      }
      if( ev.deltaY < 0 ){
        output = currentZ + zoomStep;
      }
      if( ev.deltaY > 0 ){
        output = currentZ - zoomStep;
      }
      if( ev.deltaY === 0 ){
        output = currentZ;
      }
      if(currentZ === null) {
        output = 1;
      }
    } else {
      output = lastPosZ * ev.scale;
    }

    if (output > maxZoom) {
      output = maxZoom;
    } else if (output < minZoom) {
      output = minZoom;
    }
    currentZ = output;

    this.setState({ currentZ });
    return 'scale(' + currentZ + ')';
  };

  saveZoom = () => {
    lastPosZ = currentZ;
    this.calculateZoomPercentage();
  };

  calculateZoomPercentage = () => {
    const zoomBarPercentage = parseInt(((lastPosZ - minZoom) * 100) / (maxZoom - minZoom), 10);
    this.setState({ zoomBarPercentage })
  };

  zoomDesktop = (inOrOut) => {
    const event = {
      fake: true,
      type: 'wheel',
      deltaY: inOrOut,
      deltaX: 0
    };

    this.mapMove(event);
    this.saveZoom();
    this.calculateZoomPercentage();
  };


  mapMove = (ev) => {
    let transform = [];
    let foo = this.scaleObject(ev);
    transform.push(foo);

    if (ev.type === 'wheel') {
      transform.push('translate3d(' + lastPosX + '%, ' + lastPosY + '%, 0)');
    } else {
      transform.push(this.panObject(ev));
    }

    let elem = document.querySelector('#draggable');

    elem.style.transform = transform.join(" ");
  };

  onRouteChange() {
    document.querySelector('body').classList.remove('noScroll');
    document.querySelector('html').classList.remove('noScroll');

    if (window.location.pathname === '/') {
      document.querySelector('body').classList.add('noScroll');
      document.querySelector('html').classList.add('noScroll');
    }
  }

  keyMapper = () => {
    let buffer = "";
    let lastKeyTime = Date.now();
    document.addEventListener('keydown', event => {
      const charList = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@0123456789.';
      const key = event.key;
      if (charList.indexOf(key) === -1) return;
      const currentTime = Date.now();
      if (currentTime - lastKeyTime > 1000) {
        buffer = "";
      }
      buffer += key;
      lastKeyTime = currentTime;
      if (buffer === "DukeNukemGlobalandXLForever.TM") {
        if (window.sessionStorage.getItem('fired') !== 'true') {
          this.onBlow();
          window.sessionStorage.setItem('fired', 'true');
        }
      }
    });
  }

  componentDidMount() {
    this.calculateZoomPercentage();
    document.addEventListener('DOMContentLoaded', this.keyMapper());

    document.querySelector('body').classList.add('noScroll');
    document.querySelector('html').classList.add('noScroll');

    document.documentElement.scrollTop = 0;

    //Set the position to last known...
    document.querySelector('#draggable').style.transform = 'translate3d(' + lastPosX + '%, ' + lastPosY + '%, 0) scale(' + currentZ + ')';

    if (!desktop) {
      this.props.history.listen(this.onRouteChange.bind(this));
    }

    const area = document.querySelector('#gameMap');

    let mc = new Hammer(area);
    mc.add( new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 }) );
    mc.get('pinch').set({ enable: true, threshold: 0 });

    mc.on('pinch pan', this.mapMove);
    mc.on('pinchend', this.saveZoom);

    const self = this;
    area.addEventListener('wheel', function(ev) {
      window.setTimeout(self.mapMove(ev), 50);
      self.saveZoom();
    });

    // Handle click outside list view somewhere on map
    const desktopMap = document.getElementsByClassName('map')[0];
    if (desktopMap) {
      desktopMap.addEventListener('mousedown', this.handleOutsideClick);
    }

    this.animate(850, 400, "balloon", [-100, -93.35], [100, 93.35], [0, 60]);
    this.animate(550, 0, "cloud--1", [-100, -93.35], [100, 93.35], [0, 15]);
    this.animate(550, -250, "cloud--2", [-100, -93.35], [100, 93.35], [0, 15]);
    this.animate(585, -100, "cloud--3", [-100, -93.35], [100, 93.35], [0, 60]);
    this.animate(535, -400, "cloud--4", [-100, -93.35], [100, 93.35], [0, 60]);
    this.animate(90, 0, "airplane", [100, -93.35], [-100, 93.35], [0, 50], 3);

  }

  componentWillUnmount() {
    const desktopMap = document.getElementsByClassName('map')[0];
    if (desktopMap) {
      desktopMap.removeEventListener('mousedown', this.handleOutsideClick);
    }
    document.removeEventListener('DOMContentLoaded', this.keyMapper());
    cancelAnimationFrame(this.raf);
  }

  getPosition = (progress, totalDistance, radians, initPos, targPos) => {
    const xDelta = (totalDistance * progress) * Math.cos(radians);
    const yDelta = (totalDistance * progress) * Math.sin(radians);

    const x = (initPos[0] > targPos[0] ? initPos[0] - xDelta : initPos[0] + xDelta);
    const y = (initPos[1] > targPos[1] ? initPos[1] - yDelta : initPos[1] + yDelta);
    return [x, y];
  }

  animate = (duration, delay, element, startPosition, endPosition, offset, wait = 1, ignoreTiming = false) => {
    const elem = document.getElementById(element);
    if(!elem) return;

    const offsetX = offset[0];
    const offsetY = offset[1];

    //Calculate position with percentages from elem's original pos.
    const X1 = startPosition[0];
    const Y1 = startPosition[1];

    const X2 = endPosition[0];
    const Y2 = endPosition[1];

    const deltaX = Math.abs(X2 - X1);
    const deltaY = Math.abs(Y2 - Y1);

    const distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    const radians = Math.asin(deltaY / distance);

    //Time form s to ms
    duration = duration * 1000;
    delay = -(delay * 1000);

    elem.style.top = offsetY + "%";
    elem.style.left = offsetX + "%";
    //set initial pos;
    let initialProgress = ((Date.now() % duration) / duration) + (delay / duration);
    if(ignoreTiming) initialProgress = Date.now();
    let start = null;
    let end = null;

    const step = (ts) => {
      if (start === null) {
        start = ts;
        end = start + duration;
      }
      ts = Math.min(ts, end);

      const progress = (ts - start) / (end - start); // is percentage
      if(progress + initialProgress > 1) initialProgress = 0;
      const [x, y] = this.getPosition(progress + initialProgress, distance, radians, startPosition, endPosition);

      elem.style.transform = 'translate3d(' + (x) + '%, ' + (y) + '%, 0)';

      if (ts >= end) {
        elem.style.transform = 'translate3d(' + (X1) + '%, ' + (Y1) + '%, 0)';
        start = null;
      }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }


  /**
   * This method handles click events (ignores drags) on the map element.
   * When you click on the map and not on an element on the map, we go back to the map view
   * and close the list view.
   */
  handleOutsideClick = (ev) => {
    if (document.getElementsByClassName('desktop-map')[0] && !this.props.history.location.pathname.startsWith('/taxes')) {
      const { props } = this;
      const desktopMap = document.getElementsByClassName('map')[0];
      let dragged = false;

      const handleMouseMove = () => {
        dragged = true;
        document.body.removeEventListener('mousemove', handleMouseMove);
      };
      document.body.addEventListener('mousemove', handleMouseMove);

      const handleMouseUp = () => {
        if (!dragged && ev.target.nodeName === 'DIV' && ev.target.classList.contains('map') && props.history.location.pathname !== '/') {
          props.history.push('/');
        }
        desktopMap.removeEventListener('mouseup', handleMouseUp);
      };
      desktopMap.addEventListener('mouseup', handleMouseUp);
    }
  };

  onBlow = () => {
    if(this.state.nuuk === true) return;
    this.setState({
      nuuk: true,
    }, () => {
      this.animate(30, 0, "nuuk", [-100, -93.35], [100, 93.35], [0, 35], 1, true);
    })

    window.setTimeout(() => {
      this.refs.boomRef.loop = false;
      this.refs.boomRef.play();
    }, 13500);

    window.setTimeout(() => {
      this.initBoom();
    }, 15000);

    window.setTimeout(() => {
      this.setState({
        nuuk: false,
      })
    }, 30000);
  }

  initBoom = () => {
    this.setState({
      boom: true,
      fallout: true,
      nuke: false,
    });

    window.setTimeout(() => {
      this.setState({
        boom: false,
      })
    }, 17500);

    window.setTimeout(() => {
      this.setState({
        fallout: false,
      })
    }, 20000);
  }

  render() {
    return (
      <div id="gameMap" className={this.props.unHighlight ? 'unHighlight' : ''}>
        <div id="draggable" ref={this.draggable} style={{top: this.state.mapTop, left: this.state.mapLeft}}>
          <div className={`cloudContainer ${this.state.boom ? 'boom' : ''}`}>
            <div id={"balloon"} className="cloudWrap balloon animated-map-element">
              <BalloonEl />
            </div>
            <div id={'cloud--1'} className="cloudWrap cloud--1 animated-map-element">
              <img src={Cloud01} alt={"Cloud"} />
            </div>
            <div id={'cloud--2'} className="cloudWrap cloud--2 animated-map-element">
              <img src={Cloud02} alt={"Cloud"} />
            </div>
            <div id={'cloud--3'} className="cloudWrap cloud--3 animated-map-element">
              <img src={Cloud01} alt={"Cloud"} />
            </div>
            <div id={'cloud--4'} className="cloudWrap cloud--4 animated-map-element">
              <img src={Cloud02} alt={"Cloud"} />
            </div>
            <div id={'airplane'} className="cloudWrap airplane animated-map-element">
              <img src={Plane} alt={"Airplane"} />
            </div>
            {!this.state.nuuk ? null :
              <div id={"nuuk"} className="cloudWrap nuuk animated-map-element">
                <Radiator />
              </div>
            }
          </div>
          <div className={`map ${this.state.boom ? 'boom' : ''}`} ref={this.mapElement} style={this.state.fallout ? { backgroundImage: "url(" + MapImageFallout + ")" } : { backgroundImage: "url(" + MapImage + ")" }}>
            {!this.state.boom ? null :
              <div className={'boom'}/>
            }
            <audio ref={'boomRef'} autoPlay={false}>
              <source src={Boom} type="audio/mp3" />
            </audio>
            {this.props.children}
          </div>
        </div>
        {
          desktop ? (
            <div className={'desktop-zoom'}>
              <span className={'zoombutton'} onClick={this.zoomDesktop.bind(this, 1)}>
                <img src={Minus} alt={'zoom-out'}/>
              </span>
              <div className={'bar'}>
                <span style={{width: this.state.zoomBarPercentage + '%'}}/>
              </div>
              <span className={'zoombutton'} onClick={this.zoomDesktop.bind(this, -1)}>
                <img src={Plus} alt={'zoom-in'}/>
              </span>
            </div>
          ) : null
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/MapView.js